import * as tslib_1 from "tslib";
import { ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UiNotificationService } from './ui-notification.service';
var GlobalErrorHandler = /** @class */ (function (_super) {
    tslib_1.__extends(GlobalErrorHandler, _super);
    function GlobalErrorHandler(injector) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        return _this;
    }
    GlobalErrorHandler.prototype.handleError = function (error) {
        _super.prototype.handleError.call(this, error);
        var uiNotificationService = this.injector.get(UiNotificationService);
        if (error instanceof HttpErrorResponse) {
            this.handleHttpError(error, uiNotificationService);
        }
        else {
            this.handleClientError(error, uiNotificationService);
        }
    };
    GlobalErrorHandler.prototype.handleHttpError = function (error, uiNotificationService) {
        if (window && window["env"]["debug"] === 'TRUE') {
            uiNotificationService.handleHttpError(error);
        }
    };
    GlobalErrorHandler.prototype.handleClientError = function (error, uiNotificationService) {
        if (error.stack && error.stack.includes('AkitaEntityNotExistsError.AkitaError')) {
            return;
        }
        if (window && window["env"]["debug"] === 'TRUE') {
            uiNotificationService.handleClientError(error);
        }
    };
    return GlobalErrorHandler;
}(ErrorHandler));
export { GlobalErrorHandler };
